export const PLAYBACK_RATES = [0.5, 0.6, 0.8, 1, 1.2, 1.5, 2];

const KOLLUS_IFRAME_SRC = 'v.kr.kollus.com';

const EXCLUDED_IFRAME_IDS = ['aodChild'];

const isKollusIframe = (element) => {
  if (element?.tagName !== 'IFRAME') return false;
  if (!element.src?.includes(KOLLUS_IFRAME_SRC)) return false;
  if (EXCLUDED_IFRAME_IDS.includes(element.id)) return false;
  return true;
};

export const applyKollusPlaybackRatesToIframe = (iframe, currentRate = 1) => {
  if (!iframe) return null;
  if (!isKollusIframe(iframe)) return null;
  if (!window.VgControllerClient || !iframe.contentWindow) return null;

  try {
    const controller = new window.VgControllerClient({
      target_window: iframe.contentWindow,
    });

    const applyPlaybackRates = () => {
      controller.set_playback_rates?.(JSON.stringify(PLAYBACK_RATES));
      controller.set_speed?.(currentRate);
    };

    if (typeof controller.on === 'function') {
      controller.on('loaded', () => {
        if (typeof controller.set_speed === 'function') {
          controller.set_speed(currentRate);
        }
      });

      controller.on('ready', () => {
        try {
          controller.set_speeds(JSON.stringify(PLAYBACK_RATES));
          controller.set_speed(currentRate);
        } catch (e) {
          console.error('ready error', e);
        }
      });

      controller.on('done', () => {
        setTimeout(() => {
          controller.set_speed?.(currentRate);
        }, 500);
      });
    }

    iframe.addEventListener('load', applyPlaybackRates);
    applyPlaybackRates();

    const timers = [
      window.setTimeout(applyPlaybackRates, 300),
      window.setTimeout(applyPlaybackRates, 800),
      window.setTimeout(applyPlaybackRates, 1500),
    ];

    return () => {
      iframe.removeEventListener('load', applyPlaybackRates);
      timers.forEach((timerId) => window.clearTimeout(timerId));
    };
  } catch (e) {
    console.log('[Kollus] initialize failed', e);
    return null;
  }
};

export const observeKollusIframes = () => {
  const cleanupMap = new WeakMap();

  const applyAllKollusIframes = () => {
    document.querySelectorAll(`iframe[src*="${KOLLUS_IFRAME_SRC}"]`).forEach((iframe) => {
      if (cleanupMap.has(iframe)) return;
      if (EXCLUDED_IFRAME_IDS.includes(iframe.id)) return;

      const cleanup = applyKollusPlaybackRatesToIframe(iframe);

      if (cleanup) {
        cleanupMap.set(iframe, cleanup);
      }
    });
  };

  applyAllKollusIframes();

  const observer = new MutationObserver(() => {
    applyAllKollusIframes();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  return () => {
    observer.disconnect();

    document.querySelectorAll(`iframe[src*="${KOLLUS_IFRAME_SRC}"]`).forEach((iframe) => {
      const cleanup = cleanupMap.get(iframe);

      if (cleanup) {
        cleanup();
      }
    });
  };
};
